import MapElement from "./MapElement";
import GeoJSON from 'ol/format/GeoJSON';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import geojsonvt from 'geojson-vt';
import Projection from 'ol/proj/Projection';
import { transformExtent } from 'ol/proj';
import Vector from 'ol/source/Vector';

export default class MapGeoJson extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent);
        this.extent = null;
    }

    drawLayer(projection, data, callback) {
        // Converts geojson-vt data to GeoJSON
        var replacer = function (key, value, zxy) {
            if (value && value.geometry) {
                var type;
                var rawType = value.type;
                var geometry = value.geometry;

                if (rawType === 1) {
                    type = "MultiPoint";
                    if (geometry.length == 1) {
                        type = "Point";
                        geometry = geometry[0];
                    }
                } else if (rawType === 2) {
                    type = "MultiLineString";
                    if (geometry.length == 1) {
                        type = "LineString";
                        geometry = geometry[0];
                    }
                } else if (rawType === 3) {
                    type = "Polygon";
                    if (geometry.length > 1) {
                        type = "MultiPolygon";
                        geometry = [geometry];
                    }
                }
                const { tags } = value;
                return {
                    type: "Feature",
                    geometry: {
                        type: type,
                        coordinates: geometry
                    },
                    // not working
                    properties: tags
                    // working with unique property
                    // properties: { ...tags, zxy }
                    // strange not working with random number
                    // properties: { ...tags, zxy: Math.random() }
                };
            } else {
                return value;
            }
        };

        // convert geojson from projection to map projection
        // Note: for some reason we need to convert to EPSG:4326 and not to the mapmodel projection
        var formatdata = new GeoJSON();
        var features = formatdata.readFeatures(data, { dataProjection: projection, featureProjection: "EPSG:4326" });
        var json = formatdata.writeFeaturesObject(features);

        // get an extent for this data
        this.extent = transformExtent(new Vector({
            features: new GeoJSON().readFeatures(json)
        }).getExtent(), "EPSG:4326", this.mapModel.projection);

        // These settings can be tweaked to get different performance
        const tileIndex = geojsonvt(json, {
            maxZoom: 24,
            tolerance: 8, // simplification tolerance (higher means simpler)
            extent: 4096,
            debug: 1,
        });

        const format = new GeoJSON({
            // Data returned from geojson-vt is in tile pixel units
            dataProjection: new Projection({
                code: 'TILE_PIXELS',
                units: 'tile-pixels',
                extent: [0, 0, 4096, 4096],
            }),
        });
        var vectorSource = new VectorTileSource({
            format: new GeoJSON({
                // Data returned from geojson-vt is in tile pixel units
                dataProjection: new Projection({
                    code: "TILE_PIXELS",
                    units: "tile-pixels",
                    extent: [0, 0, 4096, 4096]
                })
            }),
            tileUrlFunction: function (tileCoord) {
                return JSON.stringify(tileCoord);
            }
        });
        var defaultTileLoadFunction = vectorSource.getTileLoadFunction();
        vectorSource.setTileLoadFunction(function (tile, url) {
            var tileCoord = JSON.parse(url);
            var data = tileIndex.getTile(tileCoord[0], tileCoord[1], tileCoord[2]);
            var geojson = JSON.stringify(
                {
                    type: "FeatureCollection",
                    features: data ? data.features : []
                },
                (key, value) => {
                    return replacer(
                        key,
                        value,
                        `${tileCoord[0]}/${tileCoord[1]}/${tileCoord[2]}`
                    );
                }
            );
            defaultTileLoadFunction(
                tile,
                "data:application/json;charset=UTF-8," + geojson
            );
        });

        var vectorTileLayer = new VectorTileLayer({
            source: vectorSource,
            zIndex: 200,
            extentData: this.extent
        });

        this.layer = vectorTileLayer;

        //this.mapModel.map.addLayer(this.layer);
        if (this.parent && this.parent.layer) {
            this.parent.layer.getLayers().push(this.layer);
        }

        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }

        if (callback) {
            callback(this.id);
        }
    }

    getExtent() {
        return this.extent;
    }
}